import '../styles/skill.scss'
import Fade from 'react-reveal/Fade';

const Skill = (props) => {

    return (
        <Fade><div className = "skill">
            <img alt = {props.name} src = {"./images/skills/"+props.image+".png"} className = "skill__image"></img>
            <div className = "skill__name">{props.name}</div>
            {/*<div className = "skill__description">{props.description}</div> */}
        </div>
        </Fade>

    )
}
export default Skill